import clsx from 'clsx';

import styles from './InternalMenu.module.scss';
import { InternalMenuItem } from './InternalMenuItem';

export const NilInternalMenu = [
  { key: 1, name: 'nil news', href: '/nil/news/', paramName: '/nil/news/' },
  {
    key: 2,
    name: 'valuations / rankings',
    href: '/nil/rankings/',
    paramName: 'rankings',
  },
  {
    key: 3,
    name: 'deal tracker',
    href: '/nil/deals/',
    paramName: 'nil/deals',
  },
  {
    key: 4,
    name: 'collectives',
    href: '/nil/collectives/',
    paramName: 'collectives',
  },
  {
    key: 5,
    name: 'compliance / resources',
    href: '/nil/resources/news/',
    paramName: 'laws',
  },
];

export interface IInternalMenuItemProps {
  key: number;
  name: string;
  href: string;
  paramName: string;
}
interface IInternalMenuProps {
  list: IInternalMenuItemProps[];
  className?: string;
}
export const InternalMenu = ({ list, className }: IInternalMenuProps) => {
  return (
    <ul className={clsx(styles.internalContainer, className)}>
      {list.map((item) => {
        return <InternalMenuItem {...item} key={item.key} />;
      })}
    </ul>
  );
};
